import { ChartDataset } from "chart.js";
import { MutableRefObject } from "react";
import ChartDatasetUtils from "./ChartDatasetUtils";
import { NullableChartPeriod } from "./CleanChart.control";
import { ChartLabelsAndData } from "./HashChart";
import { dev } from "@utils/dev";
import { Moment } from "moment-timezone";

function createNew(
  lastTime: number | null,
  lastValue: number | null,
  newTime: number,
  newValue: number,
  timeDiscrete: number,
  speedDrops?: number,
  defaultSpeed?: number
): ChartLabelsAndData {
  const result: ChartLabelsAndData = {
    data: [],
    labels: [],
    status: [],
    accepted: [],
    rejected: [],
  };
  result.labels = ChartDatasetUtils.createCalculatedDates(
    lastTime,
    newTime,
    timeDiscrete
  );
  result.data = ChartDatasetUtils.createAvgValues(
    newValue,
    result.labels.length
  );
  if (speedDrops !== undefined && defaultSpeed !== undefined) {
    return ChartDatasetUtils.appendBounds(
      result,
      defaultSpeed,
      speedDrops,
      lastTime,
      lastValue
    );
  }
  return result;
}

export function appendValueToChartDataset(
  dataset: ChartDataset<"line", number[]>,
  labels: number[],
  timeSec: number,
  value: number,
  periodInSec: number,
  countRef: MutableRefObject<number>,
) {

  let lastTime: number | null = null;
  let lastValue: number | null = null;

  const labelIdx = labels.indexOf(timeSec * 1000);

  //dev.logt("Charts", `appendValueToChartDataset ${tag}`, { value, labelIdx, timeSec });

  dev.logt("Charts", "appendValueToChartDataset Dataset:", { dataset, labelIdx });

  if (labelIdx === -1) { // если на это время нет показания

    //dev.logt("Charts", "appendValueToChartDataset", { labelIdx, timeSec });

    if (labels.length > 1 && countRef.current > 1) {
      lastTime = Math.floor(labels[labels.length - 1] as number / 1000);
      lastValue = dataset.data[dataset.data.length - 1];
      if (lastTime % periodInSec !== 0) {

        //dev.logt("Charts", "append new POP last values");

        labels.pop();
        dataset.data.pop();
        countRef.current--;
        if (labels.length > 0) {
          lastTime = Math.floor(labels[labels.length - 1] as number / 1000);
          lastValue = dataset.data[dataset.data.length - 1];
        }
      }
    }
    const values = createNew(
      (lastTime ?? 0) * 1000,
      lastValue,
      timeSec * 1000,
      value,
      periodInSec * 1000
    );
    labels.push(...values.labels);
    dataset.data.push(...values.data);
    //dev.logif("Charts", `TRY appendValueToChartDataset ${tag}`, () => tag !== undefined, { value, labelIdx });

    countRef.current++;
  } else {
    while (dataset.data.length <= labelIdx) {
      dataset.data.push(NaN);
    }
    dataset.data[labelIdx] = value;
    // dev.logif("Charts", `appendValueToChartDataset ${tag}`, () => tag !== undefined, { value });
  }

}

export function parseLocationId(id: string | undefined): number {
  if (id) {
    try {
      return parseInt(id);
    } catch {
      return -1;
    }
  }
  return -1;
}

function areMomentsEqual(a: Moment | null, b: Moment | null): boolean {
  if (a === null && b === null) {
    return true;
  }
  if (a === null || b === null) {
    return false;
  }
  return a.isSame(b);
}

export function isChartPeriodsIsSame(
  a: NullableChartPeriod,
  b: NullableChartPeriod
): boolean {
  const [a0, a1] = a;
  const [b0, b1] = b;
  let result = false;
  if (areMomentsEqual(a0, b0) && areMomentsEqual(a1, b1)) {
    result = true
  }
  return result;
}